import type { AmazonPlaybackQuality } from '@amzn/vinyl-amzn'
import { type ObservableValue, externalData } from '@amazon/vinyl-observable'
import type { Player } from '@/playback/api'

/**
 * Returns a data provider for the player's playback quality.
 */
export function getPlaybackQuality(deps: {
    readonly player: Player
}): ObservableValue<AmazonPlaybackQuality | null> {
    const { player } = deps
    return externalData(player.playbackQualityAmzn, (setData) => {
        return player.on('playbackQualityChange', () => {
            setData(player.playbackQualityAmzn)
        })
    })
}
